import { CaptureUpdateAction } from "@excalidraw/element";

import { adjustmentsIcon } from "../components/icons";

import { register } from "./register";

export const actionToggleSettings = register({
  name: "toggleSettings",
  label: "settings.title",
  icon: adjustmentsIcon,
  viewMode: false,
  trackEvent: { category: "menu" },
  keywords: ["settings", "preferences", "configuration"],
  perform(elements, appState) {
    return {
      appState: {
        ...appState,
        openDialog:
          appState.openDialog?.name === "settings"
            ? null
            : { name: "settings" },
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
});
